export default "__VITE_PUBLIC_ASSET__a0d256d2__"